import { render, staticRenderFns } from "./mc-sync.vue?vue&type=template&id=b0235f84"
import script from "./mc-sync.ts?vue&type=script&lang=js&external"
export * from "./mc-sync.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports